// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../client/web/myagent/app/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../client/web/myagent/app/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../../../client/web/myagent/app/node_modules/css-loader/dist/cjs.js!../styles/variables.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile-panel {
  padding: var(--spacing-xl) var(--spacing-2xl);
  display: flex;
  flex-direction: column;
  gap: var(--spacing-lg);
  height: 100%;
  overflow-y: auto;
  max-width: 640px;
  margin: 0 auto;
  width: 100%;
}

.profile-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--spacing-sm);
  padding: var(--spacing-xl) var(--spacing-lg);
  background: var(--glass-bg);
  border: 1px solid var(--glass-border);
  border-radius: var(--radius-xl);
}

.profile-avatar-img {
  width: 72px;
  height: 72px;
  border-radius: var(--radius-full);
  object-fit: cover;
  border: 2px solid transparent;
  background: linear-gradient(var(--bg-secondary), var(--bg-secondary)) padding-box,
    linear-gradient(135deg, var(--color-primary), var(--color-accent)) border-box;
}

.profile-avatar-initials {
  width: 72px;
  height: 72px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, var(--color-primary), var(--color-secondary));
  color: white;
  font-size: var(--font-size-2xl);
  font-weight: var(--font-weight-semibold);
  border-radius: var(--radius-full);
}

.profile-name {
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-semibold);
  color: var(--text-primary);
  margin-top: var(--spacing-sm);
}

.profile-email {
  font-size: var(--font-size-sm);
  color: var(--text-secondary);
  word-break: break-all;
}

.profile-logout-btn {
  width: 100%;
  padding: var(--spacing-sm) var(--spacing-md);
  background: linear-gradient(135deg, var(--color-error), #dc2626);
  color: white;
  border: none;
  border-radius: var(--radius-md);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
  cursor: pointer;
  transition: all var(--transition-base);
}

.profile-logout-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px var(--color-error-glow);
}
`, "",{"version":3,"sources":["webpack://./../../../../packages/apps/myagent/myagent_ui/src/components/ProfilePanel.css"],"names":[],"mappings":"AAEA;EACE,6CAA6C;EAC7C,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;EACtB,4CAA4C;EAC5C,2BAA2B;EAC3B,qCAAqC;EACrC,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,iBAAiB;EACjB,6BAA6B;EAC7B;iFAC+E;AACjF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iFAAiF;EACjF,YAAY;EACZ,+BAA+B;EAC/B,wCAAwC;EACxC,iCAAiC;AACnC;;AAEA;EACE,8BAA8B;EAC9B,wCAAwC;EACxC,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,4CAA4C;EAC5C,gEAAgE;EAChE,YAAY;EACZ,YAAY;EACZ,+BAA+B;EAC/B,8BAA8B;EAC9B,sCAAsC;EACtC,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD","sourcesContent":["@import \"../styles/variables.css\";\n\n.profile-panel {\n  padding: var(--spacing-xl) var(--spacing-2xl);\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-lg);\n  height: 100%;\n  overflow-y: auto;\n  max-width: 640px;\n  margin: 0 auto;\n  width: 100%;\n}\n\n.profile-card {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: var(--spacing-sm);\n  padding: var(--spacing-xl) var(--spacing-lg);\n  background: var(--glass-bg);\n  border: 1px solid var(--glass-border);\n  border-radius: var(--radius-xl);\n}\n\n.profile-avatar-img {\n  width: 72px;\n  height: 72px;\n  border-radius: var(--radius-full);\n  object-fit: cover;\n  border: 2px solid transparent;\n  background: linear-gradient(var(--bg-secondary), var(--bg-secondary)) padding-box,\n    linear-gradient(135deg, var(--color-primary), var(--color-accent)) border-box;\n}\n\n.profile-avatar-initials {\n  width: 72px;\n  height: 72px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(135deg, var(--color-primary), var(--color-secondary));\n  color: white;\n  font-size: var(--font-size-2xl);\n  font-weight: var(--font-weight-semibold);\n  border-radius: var(--radius-full);\n}\n\n.profile-name {\n  font-size: var(--font-size-lg);\n  font-weight: var(--font-weight-semibold);\n  color: var(--text-primary);\n  margin-top: var(--spacing-sm);\n}\n\n.profile-email {\n  font-size: var(--font-size-sm);\n  color: var(--text-secondary);\n  word-break: break-all;\n}\n\n.profile-logout-btn {\n  width: 100%;\n  padding: var(--spacing-sm) var(--spacing-md);\n  background: linear-gradient(135deg, var(--color-error), #dc2626);\n  color: white;\n  border: none;\n  border-radius: var(--radius-md);\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-medium);\n  cursor: pointer;\n  transition: all var(--transition-base);\n}\n\n.profile-logout-btn:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px var(--color-error-glow);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
